
import Model from './model';
import config from './../config';
import {extend} from './../zviz2/zviz/functions';
import state from './../zviz2/zviz/state';
import ModelCollection from './../zviz2/zviz/modelcollection'

class Details extends Model{

    constructor(name=null, settings={}){

        settings = extend(settings, {
            endpoint: config.root + 'evaluation',
            method: 'GET',
            listeners: [
                (model) => ( model.addListener(state, [model, model.update], 'list.details_id') ),
                (model) => ( model.addListener(state, [model, model.updateSource], 'filter') ),
                (model) => ( model.addListener(state, [model, model.updateSource], 'source') )
            ]   
        });
        
        super(name, settings);

        this.cache = new Map();

        this.defaultSelects = ['region', 'donor_cat', 'strategic_objective'];
        this.metrics = ['budget', 'expenditure', 'project'];

        this.items = [];
        this.details = {};
        
        this.dimensionRegion = 'region';
        this.dimensionTheme = 'theme';

        this.lastSource = null;
        this.lastFilter = '[]';

        this.update();

    }

    updateSource(){
        state.set('list.details_id', null);
        this.update();
    }

    getSelect(){
        let f = state.get('filter') || {};
        f['planned_flag'] = true; // set the right value in processFilter
        if(f.year){
            f['eval_rpt_end_year'] = f.year.slice(0);
            delete f.year;
        }
        let filter = this.processFilter(f);
        let item = state.get('list.details_id');
        item = (item instanceof Array)? item[0]: item;
        let input = {
            'filter': filter,
            // 'source': state.get('source')
        };
        this.processSearch(input, f);

        if(state.get('source') == 'll'){
            input['item'] = '/ll/';
        }else if(state.get('source') == 'gp'){
            input['item'] = '/gp/';
        }else if(state.get('source') == 'rec'){
            input['item'] = '/rec/';
        }else{
            input['item'] = '/eval/';
        }

        if(item){
            input['item'] += item;
        }
        // input['columns'] = this.getColumns(!!item);
        // input['columns'] = this.convertToRequestColumns(input['columns']);

        // input['countField'] = this.getCountField();
        return input;
    }

    getEndpoint(){
        let item = '';
        if(this.select['item']){
            item = this.select['item'];
        }
        delete this.select['item'];
        return this.endpoint + item;
    }
    

    getCountField(){
        let source = state.get('source');
        if(source == 'll'){
            return 'll_id';
        }else if(source == 'gp'){
            return 'gp_id';
        }else if(source == 'rec'){
            return 'rec_id';
        }

        return 'eval_id';
    }

    getColumns(getDetails=false, exportColumns=false){
        let result = [];

        let source = state.get('source');        
        // this.getDimensions();
        if(getDetails){
            return this.getDetailsColumns(result, source, exportColumns);
        }

        if(source == 'll'){
            result = ['ll_id', 'll_desc' + (exportColumns ? '_full' : ''), 'eval_rpt_end_year'];
        }else if(source == 'gp'){
            result = ['gp_id', 'gp_desc' + (exportColumns ? '_full' : ''), 'eval_rpt_end_year'];
        }else if(source == 'rec'){
            result = ['rec_id', 'rec_desc', 'eval_rpt_end_year']; 
        }else{
            result = ['eval_id', 'eval_title', 'eval_rpt_end_year', 'tc_symbol'];
        }

        return result;
    }

    getDetailsColumns(result, source, exportColumns){
        
        if(source == 'll'){
            result = config.screens.lessonsLearned.slice(0);
            result.push('ll_id');
        }else if(source == 'gp'){
            result = config.screens.goodPractices.slice(0);
            result.push('gp_id');
        }else if(source == 'rec'){
            result = config.screens.recommendations.slice(0);
            result.push('rec_id');
        }else{
            result = config.screens.evaluations.slice(0);
            if(source == 'planned'){
                result.push('planned_completion_date');
                result = result.filter((col) => (
                    ! ['doc_type', 'completion_date'].includes(col)
                ));
            }
        }

        if(exportColumns){
            let pos = result.indexOf('doc_title');
            if(pos >= 0){
                result.splice(pos, 1);
            }

            pos = result.indexOf('doc_id');
            if(pos >= 0){
                result.splice(pos, 1);
            }

            pos = result.indexOf('theme_combined');
            if(pos >= 0){
                result[pos] = 'theme';
            }

            pos = result.indexOf('rec_theme_combined');
            if(pos >= 0){
                result[pos] = 'rec_theme';
            }

            pos = result.indexOf('gp_theme_combined');
            if(pos >= 0){
                result[pos] = 'gp_theme';
            }

            pos = result.indexOf('ll_theme_combined');
            if(pos >= 0){
                result[pos] = 'll_theme';
            }

            pos = result.indexOf('buttons');
            if(pos >= 0){
                result.splice(pos, 1);
            }

            let temp = result;
            result = [];
            let concats = ['theme_category', 'theme','eval_manager', 'funding_source'];
            for(let col of temp){
                let func = 'group';
                if(concats.indexOf(col)!=-1){
                    func = 'concat_distinct';
                }
                result.push([col, func]);
            }

            result = result.map((field) => (
                ['ll_desc', 'gp_desc'].includes(field) ? field + '_full' : field
            ));
            
        }

        return result;
    }

    convertToRequestColumns(input){
        let pos = input.indexOf('theme_combined');
        if(pos >= 0){
            input.splice(pos, 1, 'theme', 'theme_category');
        }

        pos = input.indexOf('rec_theme_combined');
        if(pos >= 0){
            input.splice(pos, 1, 'rec_theme', 'rec_theme_category');
        }

        pos = input.indexOf('gp_theme_combined');
        if(pos >= 0){
            input.splice(pos, 1, 'gp_theme', 'gp_theme_category');
        }

        pos = input.indexOf('ll_theme_combined');
        if(pos >= 0){
            input.splice(pos, 1, 'll_theme', 'll_theme_category');
        }

        pos = input.indexOf('buttons');
        if(pos >= 0){
            input.splice(pos, 1, 'll_desc', 'gp_desc', 'rec_desc');
        }

        return input;

    }

    // formatRequest(){
    //     return JSON.stringify(this.select);
    // }
    // getRequestBody(){
    //     return '';
    // }

    // no longer in use, delete?
    // getDimensions(){

    //     let dimRegion = 'country';
    //     let v = state.get('filter.country');
    //     if(! v || v == null && v != ''){
    //         v = state.get('filter.region');
    //         if(! v || v == null && v != ''){
    //             dimRegion = 'region';
    //         }
    //     }

    //     let dimTheme = 'theme';
    //     v = state.get('filter.theme');
    //     if(! v || v == null && v != ''){
    //         v = state.get('filter.theme_category');
    //         if(! v || v == null && v != ''){
    //             dimTheme = 'theme_category';
    //         }
    //     }

    //     this.dimensionRegion = dimRegion;
    //     this.dimensionTheme = dimTheme;

    //     return [dimTheme, dimRegion];
    // }


    getDataFromResponse(input){

        input = super.getDataFromResponse(input);

        if(input == null){
            return null;
        }

        let result = {};
        if(input['value']){
            result.items = [];
            for(let item of input['value']){
                result.items.push(item);                   
            }
            this.items = result.items;
        }else{
            result.items = this.items;
        }
        // requesting an item, but nothing found. Try resetting the year filter.
        const filter = state.get('filter');
        if(this.items.length == 0 && ['eval_id', 'll_id', 'gd_id', 'rec_id'].includes(Object.keys(filter))){
            console.log('Reset year filter, was: ' + filter.year);
            state.set('filter.year', null);
        }
        if(input['details']){
            delete input['details']['ll_theme_category'];
            delete input['details']['gp_theme_category'];
            delete input['details']['rec_theme_category'];
            result.details = this.getOldFormat(input['details']);
            result.details.theme_combined = this.getThemesCombined(input['details']); 
            result.details.ll_theme_combined = this.getThemesCombined(input['details'], 'll_'); 
            result.details.gp_theme_combined = this.getThemesCombined(input['details'], 'gp_'); 
            result.details.rec_theme_combined = this.getThemesCombined(input['details'], 'rec_'); 
            this.details = result.details;
        }

        return result;
    }


    getCache(){
        let success = super.getCache();
        if(success){
            this.items = this.data.items;
            if(this.data['details']){
                this.details = this.data.details;
            }
        }
        return success;
    }


    sortItems(field, direction = 1){
        if(! this.items){
            return null;
        }
        this.items.sort(function(a, b){
            let va = a[field];
            let vb = b[field];
            if(field == 'eval_id'){
                va = parseInt(va, 10) || a[field];
                vb = parseInt(vb, 10) || b[field];
            }
            if(va < vb){
                return -1 * direction;
            }else if(va > vb){
                return 1 * direction;
            }
            va = parseInt(a['eval_id'], 10);
            vb = parseInt(b['eval_id'], 10);
            return (va < vb)? -1*direction: ((va > vb)? 1*direction: 0);
        });
    }

    getUniqueEntries(input){
        let result = {};
        if(! input[0] ){
            return {};
        }
        for(let field of Object.keys(input[0])){
            result[field] = [];
            for(let i = 0; i < input.length; i++){
                let v = input[i][field];
                if(result[field].indexOf(v) == -1){
                    result[field].push(v);
                }
            }
        }
        return result;

    }

    getOldFormat(input){
        let collections = ["evaluation", "document", "gp_desc", "ll_desc", "rec_desc", "location", "theme", "rec_theme", "gp_theme", "ll_theme"];

        if(input['evaluation'] && !(input["evaluation"] instanceof Array)){
            input['evaluation'] = [input['evaluation']];
        }
        
        for(let field of collections){
            if(input[field] && (input[field] instanceof Array) && input[field].length > 0){
                if(input[field][0] != null && (typeof input[field][0] == 'object')){
                    for(let i = 0; i < input[field].length; i++){
                        let object =  input[field][i];
                        for (let property of Object.keys(object)) {
                            let p = (field == property)? 'temp_'+property: property;
                            input[p] = input[p] || [];
                            if(! (input[p] instanceof Array)){
                                console.warn('trying to merge collection with normal value for ' + property);
                            }else{
                                if((object[property] instanceof Array) && object[property].length >= 1 && input[p].length==0){
                                    input[p] = object[property].slice(0);
                                }else{
                                    input[p].push(object[property]);
                                }
                            }
                        }
                    }
                    delete input[field];
                }
            }
        }

        for (let property of Object.keys(input)) {
            if(property.substring(0, 5) == 'temp_'){
                input[property.substring(5)] = input[property];
                delete input[property]
            }
        } 
        return input;
    }

    getThemesCombined(inputRaw, type = ''){
        const input = {
            'theme': inputRaw[type + 'theme'],
            'theme_category': inputRaw[type + 'theme_category']
        };
        let result = [];
        if(! input['theme'] ){
            return [];
        }
        if(! (input['theme'] instanceof Array)){
            input['theme'] = [input['theme']];
        }
        if(! (input['theme_category'] instanceof Array)){
            input['theme_category'] = [input['theme_category']];
        }

        for(let i = 0; i < input['theme'].length; i++){
            if(input['theme'][i] && input['theme_category'][i]){
                let t = input['theme'][i];
                let found = false;
                for(let c = 0; c < result.length; c++){
                    if(result[c][1] == t){
                        found = true; 
                        break;
                    }
                }
                if(! found){
                    result.push([input['theme_category'][i], t]);
                }
            }
        }
        return result;
    }


}


ModelCollection.setModelClass('details', Details);

export default Details;